import { Component, Input, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { UserService } from 'src/app/core/service/user.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { sortBy } from 'lodash';
import { IntlService } from '@progress/kendo-angular-intl';
import { MemberService } from 'src/app/core/service/member.service';
import { Subscription } from 'rxjs';
import { MessengerService } from 'src/app/core/service/messenger.service';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';

@Component({
  selector: 'app-pinned-resource-list',
  templateUrl: './pinned-resource-list.component.html',
  styleUrls: ['./pinned-resource-list.component.scss']
})
export class PinnedResourceListComponent implements OnInit, OnDestroy
{
  @Input() public memberId: number;
  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;

  public programOpened = false;
  public deletePinnedServiceDialogOpened = false;
  public loading = true;
  public communityPrograms: any[] = [];
  public programId: number;
  public selectedServiceName = null;

  private messagingSubscription: Subscription;

  constructor(
    private userService: UserService,
    private memberService: MemberService,
    private authService: AuthenticationService,
    private messageHandlerService: MessageHandlerService,
    private messengerService: MessengerService,
    public intl: IntlService)
  {
  }

  public ngOnInit(): void
  {
    if (this.messagingSubscription === undefined)
    {
      this.messagingSubscription = this.messengerService.receiveMessage().subscribe({
        next: (message) =>
        {
          if (message.type === 'reloadPinnedServices' || message.type === 'reloadPinnedResources')
          {
            this.loadServices();
          }
        }
      });
    }
    this.loadServices();
  }

  public ngOnDestroy(): void
  {
    if (this.messagingSubscription !== undefined) { this.messagingSubscription.unsubscribe(); }
  }

  public showProgram(program: any): void
  {
    this.programId = program.id;
    this.programOpened = true;
  }

  public closeProgramDialog(): void
  {
    this.programOpened = false;
  }

  public closePinnedServiceDialog(): void
  {
    this.deletePinnedServiceDialogOpened = false;
  }

  /**
   * Delete a pinned service confirmation.
   *
   * @param program Community service object.
   */
  public deletePinnedResource(program: any): void
  {
    this.programId = program.id;
    this.selectedServiceName = program.name;
    this.deletePinnedServiceDialogOpened = true;
  }

  /**
   * Delete the selected pinned resource.
   */
  public deletePinnedService(): void
  {
    this.memberService.deletePinnedCommunityProviderProgram(this.memberId, this.programId).subscribe({
      next: () =>
      {
        this.messageHandlerService.displaySuccess('PINNED-SERVICE-DELETED');
        // Remove from list
        this.communityPrograms = this.communityPrograms.filter(x => x.id !== this.programId);
      },
      error: (errorResponse) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });
    this.deletePinnedServiceDialogOpened = false;
  }

  public showTooltip(e: ElementRef): void
  {
    this.tooltipDir.toggle(e, true);
  }
  
  public hideTooltip(): void
  {
    this.tooltipDir.hide();
  }

  private loadServices(): void
  {
    this.loading = true;
    this.communityPrograms = [];

    const currentUser = this.authService.currentUser;

    if (this.memberId !== null && this.memberId !== undefined && currentUser)
    {
      this.userService.getMemberPinnedResources(currentUser.id, this.memberId, false).subscribe({
        next: (data: any) =>
        {
          if (data.communityPrograms !== null)
          {
            data.communityPrograms.forEach(p =>
            {
              p.pinnedOn = p.pinnedOn !== null ? new Date(p.pinnedOn) : null;
            });
            this.communityPrograms = sortBy(data.communityPrograms, ['name']);
          }
          this.loading = false;
        },
        error: (errorResponse) =>
        {
          this.messageHandlerService.displayError(errorResponse);
          this.loading = false;
        }
      });
    }
  }
}
